import { faThumbsDown } from '@fortawesome/free-regular-svg-icons';
import { faCalendarAlt, faChartLine, faHandFist, faTableList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import timeGridPlugin from "@fullcalendar/timegrid";
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, } from 'chart.js';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Card, Col, Modal, Row } from 'react-bootstrap';
import { Bar, Doughnut, getElementsAtEvent } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { GET, POST } from '../../../../api';
import { brand_colors } from '../../../../helpers/brand_colors_helper';
import { handleFormErrors } from '../../../../helpers/form_helpers';
import { t } from '../../../../helpers/translation_helper';
import { LoadingPlaceholder } from '../../../_common/Loading/Loading';
import LeadTasks from '../../../CRM/LeadTasks';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
      position: 'bottom',
    },
  },
};

const doughnutChartOptions = {
  responsive: true,
  cutout: 100,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
    },
  },
};


class CRM extends Component {
  sourceChartRef = React.createRef()
  state = {
    leadStatusList: [],
    reportWaitingData: {
      referrals: null,
      leads: null,
      referralsType: null,
      source: null,
    },
    last7DaysLeads: 0,
    events: [],
    taskPreviewModal: {
      show: false,
      data: null,
    },
    tasksModal: {
      show: false,
      fetching: false,
      data: [],
      id: 0,
      waitingObject: null
    },
    waitingObject: null
  }

  componentDidMount() {
    this.reportWaiting();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authData.centerData.center_id !== this.props.authData.centerData.center_id) {
      this.reportWaiting();
    }
  }

  reportWaiting = async () => {

    this.setState({
      reportWaitingData: {
        ...this.state.reportWaitingData,
        referrals: null,
        leads: null
      }
    });

    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;

    try {
      const res = await GET('admin/report-waiting');
      if (res.status == 200) {
        // this.state.reportWaitingData?.leads?.datasets?.[0].data[2]
        let referrals = {
          labels: [],
          datasets: [
            {
              data: [],
              backgroundColor: []
            }
          ]
        };

        referrals.labels = res.data.referral_names;
        referrals.datasets[0].data = res.data.referral_totals;
        referrals.datasets[0].backgroundColor = [
          brand_colors[this.props.defaultTheme.theme_id].color1,
          brand_colors[this.props.defaultTheme.theme_id].color2,
          brand_colors[this.props.defaultTheme.theme_id].color4
        ];

        let totalLeads = res.data.waitingData.filter((v) => v.admission_id == null && v.admission_status_id == 1).length
        let totalApplicantsLeads = res.data.waitingData.filter((v) => v.admission_id != null && ![7, 8, 12].includes(v.admission_status_id)).length
        let totalRegisteredLeads = res.data.waitingData.filter((v) => v.admission_id != null && [7].includes(v.admission_status_id) && ![12].includes(v.admission_status_id)).length
        let totalLostLeads = res.data.waitingData.filter((v) => [12].includes(v.admission_status_id) || v.interested == 'N').length

        // let totalWithoutAdmissionLeads = res.data.waitingData.filter((v) => (v.interested == 'Y' || v.interested == 'R') && v.admission_id == null).length
        // let totalLostLeads = res.data.waitingData.filter((v) => v.interested != 'Y' && v.interested != 'R' && v.admission_id == null).length
        // let totalOpenLeads = res.data.waitingData.filter((v) => v.interested != 'R' && v.admission_id == null).length
        // let totalRegistered = res.data.waitingData.filter((v) => v.interested == 'R').length
        // let totalNotLostLeads = parseInt(totalLeads) - parseInt(totalLostLeads)

        let leads = {
          labels: [t('Total Leads'), t('Total Applicants'), t('Total Registered'), t('Total Lost')],
          datasets: [
            {
              data: [
                totalLeads,
                totalApplicantsLeads,
                totalRegisteredLeads,
                totalLostLeads,
              ],
              backgroundColor: [
                brand_colors[this.props.defaultTheme.theme_id].color1,
                brand_colors[this.props.defaultTheme.theme_id].color2,
                brand_colors[this.props.defaultTheme.theme_id].color4,
                brand_colors[this.props.defaultTheme.theme_id].color11,
              ]
            }
          ]
        };

        let referralsType = {
          labels: res.data.referral_type_names,
          datasets: [
            {
              data: res.data.referral_type_totals,
              backgroundColor: [
                brand_colors[this.props.defaultTheme.theme_id].color1,
                brand_colors[this.props.defaultTheme.theme_id].color2,
                brand_colors[this.props.defaultTheme.theme_id].color4
              ]
            }
          ]
        };

        let source = {
          labels: res.data.visitby_names,
          datasets: [
            {
              data: res.data.visitby_totals,
              backgroundColor: [
                brand_colors[this.props.defaultTheme.theme_id].color1,
                brand_colors[this.props.defaultTheme.theme_id].color2,
                brand_colors[this.props.defaultTheme.theme_id].color4
              ]
            }
          ]
        };

        this.setState({
          reportWaitingData: {
            ...this.state.reportWaitingData,
            referrals,
            leads,
            referralsType,
            source,
            totalLeads,
            totalApplicantsLeads,
            totalRegisteredLeads,
            totalLostLeads,
          },
          last7DaysLeads: res.data.last7DaysLeads
        });

      }

    } catch (err) {
      console.log('err', err)

      toast.error(t('Something went wrong!'));
    }
  }

  waitingCalendar = async (arg) => {
    if (arg == undefined) {
    } else {
      this.dateStart = arg.start;
      this.dateEnd = arg.end;
    }
    this.setState({
      events: null,
    });
    const { authData } = this.props;
    const { auth_key, role_id } = authData.loginData;
    const { center_id } = authData.centerData;

    const request_params = {
      startdate: moment(this.dateStart).format('YYYY-MM-DD'),
      enddate: moment(this.dateEnd).format('YYYY-MM-DD'),
      role_id,
      actionType: 'main_tab',
    };

    try {
      const res = await GET('waiting/calendar', {
        params: request_params,
      });

      if (res.status == 200) {
        this.setState({
          events: res.data.data,
        });
      }
    } catch (err) {
      console.log('err', err);

      toast.error(t('Something went wrong!'));
    }
  };

  handleOpenCalendarEventModal = (info) => {
    this.setState({
      taskPreviewModal: {
        show: true,
        data: info.event,
      }
    });
  }

  handleCloseCalendarEventModal = () => {
    this.setState({
      taskPreviewModal: {
        show: false,
        data: null,
      }
    });
  }

  handleCloseTasksModal = () => {
    this.setState({
      tasksModal: {
        fetching: false,
        data: [],
        id: 0,
        waitingObject: null,
      },
      ...this.taskFields,
    });
    this.props.onHide();
  }

  taskAttachmentHandler = (event) => {
    let id = event.target.id;
    let file_size = event.target.files[0].size;
    let file_type = event.target.files[0].type;
    let allowedTypes = [
      'image/jpeg',
      'image/gif',
      'image/png',
      'application/pdf',
    ];

    if (file_size > 2097152) {
      toast.error(t('Attachment allowed size in 2MB max!'));
      event.target.value = '';
      return;
    }

    if (!allowedTypes.includes(file_type)) {
      toast.error(t('Only image or pdf file is allowed!'));
      event.target.value = '';
      return;
    }

    this.setState({ [id]: event.target.files[0] });
  };

  getTasksList = async (waitingObject) => {
    this.setState({
      tasksModal: {
        ...this.state.tasksModal,
        fetching: true,
      },
    });

    try {
      const res = await GET('waiting/get-tasks', {
        params: {
          waiting_id: waitingObject.waiting_id,
          limit: -1,
          offset: 0,
        },
      });

      this.setState({
        tasksModal: {
          ...this.state.tasksModal,
          fetching: false,
          data: res.data.data,
          waitingObject,
          show: true,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  getCenterEmailTemplate = async (ls_id) => {
    try {
      const res = await GET('waiting/get-center-email-template', {
        params: {
          waiting_id: this.state.tasksModal.waitingObject.waiting_id,
          ls_id,
        },
      });


      this.setState({
        task_desc2: res.data,
      });
    } catch (err) {
      console.log(err);
    }
  };

  saveWaitingTask = async () => {
    const { authData } = this.props;
    const { registration_form_url, email1 } = authData.centerData;

    this.setState({ working: true });

    const {
      ls_id,
      task_duedate,
      task_reminder_date,
      task_desc1,
      task_desc2,
      tasksModal,
      attachment1,
      attachment2,
      attachment3,
      noenrolment_id,
      no_reg_reason,
    } = this.state;

    try {
      const fData = new FormData();

      fData.append(
        'waitingTaskData',
        JSON.stringify({
          ls_id: ls_id.value,
          task_duedate,
          task_reminder_date,
          task_desc1,
          task_desc2,
          waiting_id: tasksModal.waitingObject.waiting_id,
          registration_form_url,
          email1,
          noenrolment_id: noenrolment_id?.value,
          no_reg_reason,
        })
      );

      if (attachment1) {
        fData.append('attachment1', attachment1);
      }

      if (attachment2) {
        fData.append('attachment2', attachment2);
      }

      if (attachment3) {
        fData.append('attachment3', attachment3);
      }

      const res = await POST('waiting/insert-waiting-task', fData);

      if (res.data.type) {
        this.setState({
          working: false,
          ...this.taskFields
        });
        toast.success(t(res.data.message));
        this.props.fetch();
        this.getTasksList(tasksModal.waitingObject);
      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
        this.setState({ working: false });
      }
    } catch (err) {
      console.log('err', err);

      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  };

  deleteTask = async () => {
    try {
      const res = await GET('waiting/delete-waiting-task', {
        params: {
          task_id: this.state.deleteConfirm.id,
        },
      });
      this.setState({
        tasksModal: {
          ...this.state.tasksModal,
          data: this.state.tasksModal.data.filter(
            (item) => item.task_id !== this.state.deleteConfirm.id
          ),
        },
        deleteConfirm: {
          show: false,
          id: 0,
          action: () => { },
        },
      });
      toast.success(t(res.data.message));
      this.props.fetch();
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  };

  render() {
    return (
      <div className='grey-section'>
        <div className='d-flex flex-row justify-content-between'>
          <div style={{ flex: 1 }} className='mx-1'>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <Row>
                  <Col>
                    <div style={{ margin: '0 auto 20px', width: 100, height: 100, borderRadius: 50, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color13, display: 'flex', justifyContent: 'center', alignItems: 'center', opacity: 0.7 }}>
                      <FontAwesomeIcon icon={faChartLine} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color8 }} />
                    </div>
                  </Col>
                  <Col md={12} className='text-center'><strong>{t('Total Leads')}</strong></Col>
                  <Col md={12} className='text-center' style={{ fontSize: 48 }}>
                    <strong>{this.state.reportWaitingData?.totalLeads}</strong>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{ position: 'absolute', top: 10, right: 10, borderRadius: 35, }}>
                <Link
                  to={'/crm/waiting?filter=totalLeads'}>
                  <FontAwesomeIcon icon={faTableList} />
                </Link>
              </Button>
            </Card>
          </div>
          <div style={{ flex: 1 }} className='mx-1'>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <Row>
                  <Col>
                    <div style={{
                      margin: '0 auto 20px',
                      width: 100,
                      height: 100,
                      borderRadius: 50,
                      backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color2,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0.7
                    }}>
                      <FontAwesomeIcon icon={faChartLine} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color8 }} />
                    </div>
                  </Col>
                  <Col md={12} className='text-center'><strong>{t('Total Applicants')}</strong></Col>
                  <Col md={12} className='text-center' style={{ fontSize: 48 }}>
                    <strong>{this.state.reportWaitingData?.totalApplicantsLeads}</strong>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{ position: 'absolute', top: 10, right: 10, borderRadius: 35, }}>
                <Link
                  to={'/crm/waiting?filter=totalApplicants'}>
                  <FontAwesomeIcon icon={faTableList} />
                </Link>
              </Button>
            </Card>
          </div>
          <div style={{ flex: 1 }} className='mx-1'>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <Row>
                  <Col>
                    <div style={{
                      margin: '0 auto 20px',
                      width: 100,
                      height: 100,
                      borderRadius: 50,
                      backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0.7
                    }}>
                      <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color8 }} />
                    </div>
                  </Col>
                  <Col md={12} className='text-center'><strong>{t('Last 7 Days Leads')}</strong></Col>
                  <Col md={12} className='text-center' style={{ fontSize: 48 }}>
                    <strong>{this.state.last7DaysLeads}</strong>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{ position: 'absolute', top: 10, right: 10, borderRadius: 35, }}>
                <Link
                  to={'/crm/waiting?filter=totalLeads7Days'}>
                  <FontAwesomeIcon icon={faTableList} />
                </Link>
              </Button>
            </Card>
          </div>
          <div style={{ flex: 1 }} className='mx-1'>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <Row>
                  <Col>
                    <div style={{
                      margin: '0 auto 20px',
                      width: 100,
                      height: 100,
                      borderRadius: 50,
                      backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color16,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0.7
                    }}>
                      <FontAwesomeIcon icon={faHandFist} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color8 }} />
                    </div>
                  </Col>
                  <Col md={12} className='text-center'><strong>{t('Total Registered')}</strong></Col>
                  <Col md={12} className='text-center' style={{ fontSize: 48 }}>
                    <strong>{parseInt(this.state.reportWaitingData?.totalRegisteredLeads)}</strong>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{ position: 'absolute', top: 10, right: 10, borderRadius: 35, }}>
                <Link
                  to={'/crm/waiting?filter=totalRegistered'}>
                  <FontAwesomeIcon icon={faTableList} />
                </Link>
              </Button>
            </Card>
          </div>
          <div style={{ flex: 1 }} className='mx-1'>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <Row>
                  <Col>
                    <div style={{
                      margin: '0 auto 20px',
                      width: 100,
                      height: 100,
                      borderRadius: 50,
                      backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color11,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0.7
                    }}>
                      <FontAwesomeIcon icon={faThumbsDown} style={{ fontSize: 40, color: brand_colors[this.props.defaultTheme.theme_id].color8 }} />
                    </div>
                  </Col>
                  <Col md={12} className='text-center'><strong>{t('Total Lost')}</strong></Col>
                  <Col md={12} className='text-center' style={{ fontSize: 48 }}>
                    <strong>{parseInt(this.state.reportWaitingData?.totalLostLeads)}</strong>
                  </Col>
                </Row>
              </Card.Body>
              <Button
                variant='light'
                size='sm'
                title={t('View Detail List')}
                style={{ position: 'absolute', top: 10, right: 10, borderRadius: 35, }}>
                <Link
                  to={'/crm/waiting?filter=totalLost'}>
                  <FontAwesomeIcon icon={faTableList} />
                </Link>
              </Button>
            </Card>
          </div>
        </div>
        <Row>
          <Col md={3}>
            <Card
              className='border-0'
              style={{ borderRadius: 20, marginBottom: 20 }}>
              <Card.Body>
                <div className='text-center mb-2'>
                  <strong>{t('Leads')}</strong>
                </div>
                <div>
                  {this.state.reportWaitingData.leads ? <Doughnut
                    data={this.state.reportWaitingData.leads}
                    options={doughnutChartOptions}
                    height={300}
                  /> : <LoadingPlaceholder height={300} />}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card
              className='border-0'
              style={{ borderRadius: 20 }}>
              <Card.Body>
                <div className='text-center mb-2'>
                  <strong>{t('Referrals Type')}</strong>
                </div>
                <div>
                  {this.state.reportWaitingData.referralsType ? <Doughnut
                    data={this.state.reportWaitingData.referralsType}
                    options={{ ...doughnutChartOptions, cutout: 100 }}
                    height={300}
                  /> : <LoadingPlaceholder height={300} />}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card
              className='border-0'
              style={{ borderRadius: 20 }}>
              <Card.Body>
                <div className='text-center mb-2'>
                  <strong>{t('Source')}</strong>
                </div>
                <div>
                  {this.state.reportWaitingData.source ? <Bar ref={this.sourceChartRef} options={barChartOptions} data={this.state.reportWaitingData.source} height={310}
                    onClick={(event) => {
                      // console.log('event', getElementsAtEvent(this.sourceChartRef.current, event))
                    }} /> : <LoadingPlaceholder height={300} />}
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card
              className='border-0'
              style={{ borderRadius: 20 }}>
              <Card.Body>
                <div className='text-center'><strong>{t('Referrals')}</strong></div>
                <div>
                  {this.state.reportWaitingData.referrals ? <Bar options={barChartOptions} data={this.state.reportWaitingData.referrals} height={310} /> : <LoadingPlaceholder height={305} />}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Card className='border-0' style={{ borderRadius: 20 }}>
              <Card.Body>
                <div style={{ height: 600 }}>
                  <FullCalendar
                    headerToolbar={{
                      left: "today prev,next",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
                    }}
                    plugins={[
                      dayGridPlugin,
                      interactionPlugin,
                      timeGridPlugin,
                      listPlugin,
                    ]}
                    initialView='dayGridWeek'
                    datesSet={this.waitingCalendar}
                    // dateClick={() => console.log('date clicked')}
                    events={this.state.events}
                    height={'100%'}
                    eventClick={this.handleOpenCalendarEventModal}
                  />
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Modal
          centered
          show={this.state.taskPreviewModal.show}
          onHide={this.handleCloseCalendarEventModal}>
          <Modal.Header closeButton>
            <Row style={{ flex: 1 }}>
              <Col><Modal.Title>{t('Task Preview')}</Modal.Title></Col>
              <Col className='text-right pe-3'>
                <Button variant="success" onClick={() => this.setState({
                  waitingObject: {
                    waiting_id: this.state.taskPreviewModal.data.extendedProps.waiting_id,
                    phone1: this.state.taskPreviewModal.data.extendedProps.phone1,
                    email1: this.state.taskPreviewModal.data.extendedProps.email1,
                    child_name: this.state.taskPreviewModal.data.extendedProps.child_name,
                    parent_name: this.state.taskPreviewModal.data.extendedProps.parent_name,
                  }
                })}>
                  {t('Add Task')}
                </Button></Col>
            </Row>
          </Modal.Header>
          <Modal.Body>{this.state.taskPreviewModal.data?.title}</Modal.Body>
        </Modal>

        {/* Tasks Modal */}
        <LeadTasks
          onHide={() => this.setState({ waitingObject: null })}
          waitingObject={this.state.waitingObject}
          fetch={() => null} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(CRM);